const productsIndustria = [
  {
    id: 65,
    pinPos: [637.6392572771576, 34.44533900119809, 896.9618920830907],
    scale: 1.4,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 369.3145089692806,
        y: 173.5414773395916,
        z: 797.9842158004698,
      },
      target: {
        x: 370.17211169070043,
        y: 173.0467761632113,
        z: 798.1248867580312,
      },
      posMobile: {
        x: 369.3145089692806,
        y: 173.5414773395916,
        z: 797.9842158004698,
      },
      targetMobile: {
        x: 370.17211169070043,
        y: 173.0467761632113,
        z: 798.1248867580312,
      },
    },
    cameraOut: {
      pos: {
        x: 691.1291006330838,
        y: 236.72823500140657,
        z: 189.58550955135965,
      },
      target: {
        x: 691.064535299161,
        y: 236.8655446003356,
        z: 190.57393121831024,
      },
    },
  },
  {
    id: 66,
    pinPos: [1156.9194595971592, 547.7845866044723, 1269.9797556171422],
    scale: 1.7,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 713.2145333247805,
        y: 341.0895804901033,
        z: 835.1115887415195,
      },
      target: {
        x: 713.9843093217959,
        y: 341.4393124782552,
        z: 835.6455666913287,
      },
      posMobile: {
        x: 713.2145333247805,
        y: 341.0895804901033,
        z: 835.1115887415195,
      },
      targetMobile: {
        x: 713.9843093217959,
        y: 341.4393124782552,
        z: 835.6455666913287,
      },
    },
    cameraOut: {
      pos: {
        x: 691.1291006330838,
        y: 236.72823500140657,
        z: 189.58550955135965,
      },
      target: {
        x: 691.064535299161,
        y: 236.8655446003356,
        z: 190.57393121831024,
      },
    },
  },
  {
    id: 67,
    pinPos: [540.5011563632198, 905.0537803723741, 1374.5195672142963],
    animationSpeed: 0.1,
    scale: 2,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 787.3735583354048,
        y: 534.7836065481243,
        z: 912.1587976930097,
      },
      target: {
        x: 787.1289325115547,
        y: 535.331788119378,
        z: 912.9585821459991,
      },
      posMobile: {
        x: 787.3735583354048,
        y: 534.7836065481243,
        z: 912.1587976930097,
      },
      targetMobile: {
        x: 787.1289325115547,
        y: 535.331788119378,
        z: 912.9585821459991,
      },
    },
    cameraOut: {
      pos: {
        x: 691.1291006330838,
        y: 236.72823500140657,
        z: 189.58550955135965,
      },
      target: {
        x: 691.064535299161,
        y: 236.8655446003356,
        z: 190.57393121831024,
      },
    },
  },
];

export default productsIndustria;
